<template>
  <div>
    <b-button
      pill
      variant="outline-info"
      id="id-video-request-btn"
      type="button"
      class="btn btn-rounded btn-light btn-block"
      @click.prevent="embedVoiceSDK()"
      >
        <b-icon-mic />&nbsp;&nbsp;Open Voice Transcriptions
      </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "../../events/eventBus";

export default {
  props: {
    correlationId: String,
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"])
  },
  methods: {
    async embedVoiceSDK() {
      EventBus.$emit("openVoiceSDKModal", {
        correlationId: this.correlationId,
      });
    }
  }
};
</script>
